import PrivacyPromise from 'components/pages/PrivacyPromise/PrivacyPromise';
import { buildPage } from 'utils/pageHelper';
export default buildPage(PrivacyPromise, {
  fullPage: true,
  metaData: {
    title: 'Privacy Promise',
    description: 'Qmee privacy promise to users.',
  },
});
